<template>
  <div :class="`absolute z-10 top-0 bottom-0 right-0 h-full ${menuControl.width}`">
    <div class="absolute top-0 -left-2 sm:-left-4 bottom-0 z-10 py-2 sm:py-4 flex flex-col gap-3 justify-start items-center w-10 sm:w-8 h-full">
      <div
        v-show="activeMenu !== 'Disable'"
        class="flex flex-col gap-3">
        <button
          v-if="$route.path == '/salmontrack/history' || $route.path == '/salmontrack/plotting'"
          @click="backToHome()"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Halaman Utama">
          <i class="material-icons text-sm text-white font-bold">home</i>
        </button>
        <button
          v-if="activeMenu === 'Optional'"
          @click="toActiveMenu({ name: 'Optional' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Halaman Utama">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Optional', 'widgets')}}</i>
        </button>
        <button
          @click="toActiveMenu({ name: 'FilterMap' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Tampilan">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('FilterMap', 'share_location') }}</i>
        </button>
        <button
          @click="toActiveMenu({ name: 'ListKapal' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="List Kapal">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('ListKapal', 'directions_boat') }}</i>
        </button>
        <button
          @click="toActiveMenu({ name: 'Tracking' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Form Tracking">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Tracking', 'track_changes') }}</i>
        </button>
        <button
          v-if="auth.permission['plotting']"
          @click="toActiveMenu({ name: 'Plotting' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Plot Tracking">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Plotting', 'draw') }}</i>
        </button>
        <button
          @click="toActiveMenu({ name: 'Tools' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Tool Tracking">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Tools', 'architecture') }}</i>
        </button>
        <button
          @click="toActiveMenu({ name: 'Profile' })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Menu Pengguna">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Profile', 'account_circle') }}</i>
        </button>
        <button
          v-if="auth.permission['pengaturan']"
          @click="toActiveMenu({ name: 'Setting', large: true })"
          class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
          type="button"
          title="Pengaturan">
          <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Setting', 'settings') }}</i>
        </button>
      </div>
      <button
        @click="toActiveMenu({ name: 'Disable' })"
        class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
        type="button"
        title="Sembuyikan Menu">
        <i class="material-icons text-sm text-white font-bold">{{ iconMenu('Disable', 'web_asset_off', 'web_asset') }}</i>
      </button>
    </div>
    <div :class="`absolute top-0 bottom-0 left-0 right-0 z-0 w-full h-full bg-gray-500 opacity-${menuControl.opacity} sm:rounded-tl-xl sm:rounded-bl-xl`">
      <div class="flex flex-col w-full h-full">
        <div :class="`hidden sm:flex flex-col py-3 justify-center items-center opacity-${menuControl.opacity}`">
          <img
            style="width: auto; height: 64px;"
            src="../assets/images/kkp-icon.png">
        </div>
        <div class="overflow-hidden w-full h-full">
          <component :is="ComponentMenu"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import MenuOptional from './MenuOptional.vue'
import MenuFilterMap from './MenuFilterMap.vue'
import MenuListKapal from './MenuListKapal.vue'
import MenuTracking from './MenuTracking.vue'
import MenuPlotting from './MenuPlotting.vue'
import MenuTools from './MenuTools.vue'
import MenuProfile from './MenuProfile.vue'
import MenuSetting from './MenuSetting.vue'

export default {
  name: 'Menus',
  computed: {
    ...mapGetters([
      'auth',
      'menuControl',
      'activeMenu'
    ]),
    ComponentMenu: function () {
      if (this.activeMenu === 'Optional') return MenuOptional
      if (this.activeMenu === 'FilterMap') return MenuFilterMap
      if (this.activeMenu === 'ListKapal') return MenuListKapal
      if (this.activeMenu === 'Tracking') return MenuTracking
      if (this.activeMenu === 'Plotting') return MenuPlotting
      if (this.activeMenu === 'Tools') return MenuTools
      if (this.activeMenu === 'Profile') return MenuProfile
      if (this.activeMenu === 'Setting') return MenuSetting

      return MenuProfile
    }
  },
  methods: {
    ...mapActions(['toActiveMenu']),
    ...mapMutations([
      'setMapControl',
      'resetHistory',
      'resetPlotting'
    ]),
    iconMenu: function (name, icon, iconAlternative) {
      if (this.activeMenu === name) return iconAlternative || 'close'
      else return icon
    },
    backToHome: function () {
      if (this.$route.path === '/salmontrack/history') {
        this.resetHistory()
      } else if (this.$route.path === '/salmontrack/plotting') {
        this.resetPlotting()
      }

      this.setMapControl({ mode: 'main' })
      this.$router.push({ path: '/salmontrack' })
    }
  }
}
</script>
